import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m0 964a450.18 450.18 0 0 1-293.37-108.12 337.88 337.88 0 0 1 586.74 0A450.18 450.18 0 0 1 512 964zM367.31 551.37A204.63 204.63 0 1 1 512 611.3a203.27 203.27 0 0 1-144.69-59.93z m482.15 261.35a398.29 398.29 0 0 0-219.34-169.2c86.85-43.4 146.5-133.15 146.5-236.84 0-146.15-118.47-264.63-264.62-264.63S247.38 260.53 247.38 406.68c0 103.7 59.65 193.44 146.5 236.84a398.28 398.28 0 0 0-219.34 169.21 452.3 452.3 0 1 1 674.92 0z\" p-id=\"14898\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-user.svg
// module id = TX6g
// module chunks = 120